import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CircleIcon from "@mui/icons-material/Circle";

import ProfileTabPanel from "./Profile";
//import SecurityTabPanel from "./Security";
import PrivacyTabPanel from "./Privacy";
import NotificationsTabPanel from "./Notifications";
import DashboardTabPanel from "./Dashboard";
import useAccountSettings from "./useAccountSettings";
import SettingsContext from "./settingsContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <span>{children}</span>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const TABIDS = ["profile", "privacy", "noti", "dashboard"];

export default function CenterTabs() {
  const theme = useTheme();
  const { t } = useTranslation();
  const { settings, validateInput } = useContext(SettingsContext);
  const [value, setValue] = React.useState(0);

  const { accountSettings } = useAccountSettings();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const maxTabWidth = "xs";

  function CustomTabLabel({ tabId, title }) {
    // return array of tabs where an error is
    const getTabErrors = () =>
      Object.keys(settings)
        .map((key) => validateInput(key))
        .filter((validationObj) => validationObj.isValid === false)
        .map((validationObj) => validationObj.tab);

    return (
      <div>
        {title}{" "}
        {getTabErrors().includes(tabId) ? (
          <CircleIcon color="secondary" sx={{ width: 14, height: 14 }} />
        ) : null}
      </div>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "background.paper",
          boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.14)",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          aria-label="full width tabs example"
          centered
        >
          {TABIDS.map((tabId, i) => (
            <Tab
              key={tabId}
              label={
                <CustomTabLabel
                  tabId={tabId}
                  title={t(`account.${tabId}.title`) ?? tabId.toUpperCase}
                />
              }
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0} dir={theme.direction}>
        <ProfileTabPanel maxWidth={maxTabWidth} />
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <PrivacyTabPanel maxWidth={maxTabWidth} />
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <NotificationsTabPanel maxWidth={maxTabWidth} />
      </TabPanel>
      <TabPanel value={value} index={3} dir={theme.direction}>
        {accountSettings.disableDashboardSelection ? (
          <Box pt={2} pb={2} textAlign={"center"}>
            <Typography>{t("common.alerts.noAccess")}</Typography>
          </Box>
        ) : (
          <DashboardTabPanel maxWidth={maxTabWidth} />
        )}
      </TabPanel>
    </Box>
  );
}
